import { render, staticRenderFns } from "./listing-box.vue?vue&type=template&id=6b14d74c&"
import script from "./listing-box.vue?vue&type=script&lang=js&"
export * from "./listing-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports